
import React from 'react'
import '../styles/_acquisitions.scss';
import { useTranslation } from 'react-i18next';
import { HeaderPmr } from '../../components/HeaderPmr/HeaderPmr';
import { ReactComponent as IconAlertCheck } from '../../../../../assets/icons/u_alert-check.svg';
import { ReactComponent as IconAlertExclamation } from '../../../../../assets/icons/u_alert-exclamacion.svg';
import { ReactComponent as IconAlertMultyple } from '../../../../../assets/icons/u_alert-multyple.svg';
import { AcquisitionCompose } from '../../components/AcquisitionCompose/AcquisitionCompose';
import { AcquisitionProcessProduct } from '../../components/AcquisitionProcessProduct/AcquisitionProcessProduct';
import NomenclatureItem from '../../components/NomenclatureItem/NomenclatureItem';
import { acquisitionProductStatus } from '../Common/NomenclatureItems';
import { groupProcessProductsByComponent, mapGeneralInfoInDataSource } from '../../utils/Helpers/MapperHelper';
import { formatDate } from '../../utils/Helpers/DataFormatHelper';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import { NoContentView } from '../../components/NoContentView/NoContentView';
import { HasExpandProductBalanceView } from '../../utils/Validators/ReportValidations';

export const AcquisitionsSection = ({ data }) => {
    const { t } = useTranslation();
    const { formatNumber } = useNumberFormatter();

    const dataSource = data.sectionFiveAcquisition;
    const componentBalancesGrouped = groupProcessProductsByComponent(data.acquistionProcessProducts);
    const hasExpandProductBalanceView = HasExpandProductBalanceView(componentBalancesGrouped, data.showProductsInFullScreen);
    const isUniqueComponent = componentBalancesGrouped.length === 1;

    const {
        classificationPlanAcquisitions,
        compositionProcurementPlan,
        componentBalances
    } = dataSource;

    const renderIcon = qualification => {
        if (qualification == 'RED') {
            return <IconAlertMultyple />;
        } else if (qualification == 'YELLOW') {
            return <IconAlertExclamation />;
        } else {
            return <IconAlertCheck />;
        }
    };

    const getColumnsByDistribution = () => {
        if (!hasExpandProductBalanceView) return componentBalancesGrouped.length;

        return isUniqueComponent ? 1 : 2;
    }

    return (
        <section className='acquisitions-report'>
            <HeaderPmr data={mapGeneralInfoInDataSource(data)} />
            <article className="acquisitions-info-report">
                <h3 className='content-layout-title'>{t('last_adquisitions')}</h3>
                <section className='acquisitions-info-layout'>
                    {
                        !data.showProductsInFullScreen && (
                            <>
                                <div className='plan-acquisitions'>
                                    <h3 className="chart-title">{t('last_classification_plan')}</h3>
                                    <span className="chart-title">{renderIcon(classificationPlanAcquisitions.qualification)} {classificationPlanAcquisitions.qualificationPercent?.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]}</span>
                                    <div className='plan-acquisitions-content'>
                                        <h3 className='content-title'>{t('last_current_state')}</h3>
                                        <span>{classificationPlanAcquisitions.currentStatus || '-'}</span>
                                        <h3 className='content-title'>{t('last_date_last_objection_plan')}</h3>
                                        <span>{renderIcon(classificationPlanAcquisitions.qualificationLastNonObjectionDate)} {formatDate(classificationPlanAcquisitions.lastNonObjectionDate)}</span>
                                        <h3 className='content-title'>{t('new_processes_with_expired_dates')}</h3>
                                        <span>{renderIcon(classificationPlanAcquisitions.qualificationProcessExpiredDate)}
                                            {classificationPlanAcquisitions.processExpiredDate} {t('last_processes_by')} {t('dolar_sign')} {formatNumber(classificationPlanAcquisitions.amountExpiredProcesses)}
                                        </span>
                                        <h3 className='content-title'>{t('new_purchases_made')}</h3>
                                        <span>{renderIcon(classificationPlanAcquisitions.qualificationPurchaseMade)} {classificationPlanAcquisitions.purchasePercent}%</span>
                                    </div>
                                </div>
                                <div className='composition'>
                                    <div className='composition-header'>
                                        <h3 className="chart-title">{t('last_composition_procurement_plan')}</h3>
                                        <h3 className='content-title'>{t('last_total_amounts_according_status')}</h3>
                                    </div>
                                    <AcquisitionCompose compose={compositionProcurementPlan}></AcquisitionCompose>
                                </div>
                            </>
                        )
                    }
                    <div className='process-advance'>
                        <div className='process-advance-header'>
                            <h3 className="chart-title">{t('last_advance_matriz_title')}</h3>
                            <div className='process-advance-label'>
                                <span>{t('last_cost_percetage_per_product')}</span>
                                <NomenclatureItem data={acquisitionProductStatus} />
                            </div>
                        </div>
                        <div className={'process-advance-content' + (hasExpandProductBalanceView ? ' expanded' : '')}
                            style={{
                                columnCount: getColumnsByDistribution(),
                                height: !isUniqueComponent && !data.showProductsInFullScreen ? '330px' : 'fit-content',
                            }}
                        >
                            {
                                componentBalances.length ? componentBalancesGrouped?.map((component, index) => {
                                    return (
                                        <AcquisitionProcessProduct
                                            key={index}
                                            productComponent={componentBalances.find(item => item.componentNumber === component.componentNumber)}
                                            subproducts={component.subproducts}
                                            isUniqueComponent={componentBalancesGrouped.length === 1}
                                        />
                                    )
                                })
                                    : <NoContentView title={t('new_no_information_by_product')} description={t('new_the_project_does_not')} />
                            }
                        </div>
                    </div>
                </section>
            </article>
        </section >
    );
};
